export const PLAN_TYPES = Object.freeze({
    oneWeek: 'oneWeek',
    fourWeeks: 'fourWeeks',
    twelveWeeks: 'twelveWeeks',
    oneMonth: 'oneMonth',
    threeMonths: 'threeMonths',
    sixMonths: 'sixMonths',
});
